import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { toaster } from "@/utilities/toaster";
import { USZipCodeModel } from "@/store/models/usZipCode/USZipCode";
import USZipCodeModule from "@/store/modules/usZipCode.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let USZipCode = /** @class */ (() => {
    let USZipCode = class USZipCode extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "US ZipCodes";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "US ZipCodes",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.inputZipCode = new USZipCodeModel();
            this.inputNewZipCode = new USZipCodeModel();
        }
        get address() {
            return USZipCodeModule.usZipCodes;
        }
        getZipCode(zipCode) {
            var zip = Object.keys(zipCode).length;
            this.inputZipCode = new USZipCodeModel();
            this.validate("componentForAddress").then((response) => {
                USZipCodeModule.GetAddressByZipCode(this.zipCode).then((response) => {
                    if (response.usZipCodes == null) {
                        toaster.ShowError("Data Not Found");
                    }
                    else {
                        this.inputZipCode = {
                            id: this.address.id,
                            code: this.address.code,
                            city: this.address.city,
                            state: this.address.state,
                            country: this.address.country,
                        };
                    }
                });
            });
        }
        //Lifecycle
        created() {
            this.pageIsLoading = false;
        }
    };
    USZipCode = __decorate([
        Component({
            name: "USZipCode",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], USZipCode);
    return USZipCode;
})();
export default USZipCode;
